"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MobileNewbuildingPromoCarousel = require("./MobileNewbuildingPromoCarousel");
Object.keys(_MobileNewbuildingPromoCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MobileNewbuildingPromoCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileNewbuildingPromoCarousel[key];
    }
  });
});